<section [ngClass]="{'main-section': userRole.includes(rolesMaster.SchoolAdmin)}">
  <header *ngIf="userRole.includes(rolesMaster.SchoolAdmin)" class="d-flex justify-content-between align-items-center main-heading">
    <div class="d-flex align-items-center">
      <a class="btn btn-link me-3 p-0 d-block d-xl-none" data-bs-toggle="offcanvas" href="#offcanvasExample"
        role="button" aria-controls="offcanvasExample">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 7H21" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" />
          <path d="M3 12H21" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" />
          <path d="M3 17H21" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" />
        </svg></a>
      <h3 class="heading-span">
        <span>User Details</span>
      </h3>
    </div>
    <div class="d-flex pe-0">
      <div class="col-md-2 text-end">
        <button type="button" class="btn theme-btn" (click)="openCreateSchoolUserDialog()">Create School User</button>
      </div>
    </div>
  </header>
  <div [ngClass]="openedFromIndividualSchool ? 'mat-account-wrapper' : 'mat-account-wrapper user-detail-wrapper'">
    <div class="content-box user-detail-tab py-1" 
     [ngClass]="{
       'schooladmin-userdetail': userRole.includes(rolesMaster.SchoolAdmin),
       'school-user-contentbox': isSchoolUser,
       'show-school-user-contentbox' : showSchoolUser
     }">

      <div *ngIf="!showSchoolUser && !userRole.includes(rolesMaster.SchoolAdmin)" class="row">
        <div class="col-sm-3">
          <label class="blue-text fs-18 font-bold mb-0">User Details</label>
        </div>
      </div>
      <div [ngClass]="{
        'table-responsive': true,
        'tab-table': openedFromIndividualSchool,
        'custom-user-center-table': !openedFromIndividualSchool,
        'school-admin-user-table': userRole.includes(rolesMaster.SchoolAdmin),
        'mb-0': true,
        'px-3': true,
        'pt-0': true,
        'pb-3': true,
        'mx-0': true,
      }" class="table-responsive tab-table">
        <table *ngIf="filteredSchoolUsers?.length" class="table table-hover" 
          aria-describedby="This table describes the school user information">
          <thead>
            <tr>
              <th class="firstName-header">S.No</th>
              <th class="lastName-header">Title</th>
              <th class="firstName-header">First Name
                <span>
                  <mat-icon *ngIf="firstName"
                    (click)="firstName=false; sortSchoolUsers('asc', 'firstName')">arrow_upward</mat-icon>
                  <mat-icon *ngIf="!firstName"
                    (click)="firstName=true; sortSchoolUsers('desc', 'firstName')">arrow_downward</mat-icon>
                </span>
              </th>
              <th class="lastName-header">Last Name
                <span>
                  <mat-icon *ngIf="lastName"
                    (click)="lastName=false; sortSchoolUsers('asc', 'lastName')">arrow_upward</mat-icon>
                  <mat-icon *ngIf="!lastName"
                    (click)="lastName=true; sortSchoolUsers('desc', 'lastName')">arrow_downward</mat-icon>
                </span>
              </th>
              <th class="contactNumber-header">Email Address
                <span>
                  <mat-icon *ngIf="emailId"
                    (click)="emailId=false; sortSchoolUsers('asc', 'emailId')">arrow_upward</mat-icon>
                  <mat-icon *ngIf="!emailId"
                    (click)="emailId=true; sortSchoolUsers('desc', 'emailId')">arrow_downward</mat-icon>
                </span>
              </th>
              <th>Country Code
                <span>
                  <mat-icon *ngIf="countryCode"
                    (click)="countryCode=false; sortSchoolUsers('asc', 'countryCode')">arrow_upward</mat-icon>
                  <mat-icon *ngIf="!countryCode"
                    (click)="countryCode=true; sortSchoolUsers('desc', 'countryCode')">arrow_downward</mat-icon>
                </span>
              </th>
              <th class="contactNumber-header">Contact Number</th>
              <th *ngIf="viewMode" class="assign-header">Role</th>
              <th *ngIf="!viewMode" class="assign-header">Assign Role</th>
              <th class="contactNumber-header">Document</th>
              <th class="sticky-right action-header">Action</th>
            </tr>
          </thead>
          <tbody class="tbody-userlists">
            <tr *ngFor="let schoolUser of filteredSchoolUsers; index as i">
              <td class="grid-item">{{ i + 1 }}
              </td>
              <td>
                <p class="mat-account-detail user-detail-clientname mb-0">
                  {{schoolUser.title}}
                </p>
              </td>
              <td matTooltip="{{schoolUser.firstName}}">
                <p class="mat-account-detail user-detail-clientname mb-0">
                  {{schoolUser.firstName}}
                </p>
              </td>
              <td matTooltip="{{schoolUser.lastName}}">
                <p class="mat-account-detail user-detail-clientname mb-0">
                  {{schoolUser.lastName}}
                </p>
              </td>
              <td matTooltip="{{schoolUser.emailId}}">
                <div class="mat-account-detail mb-0  badge-progress"
                
                  [class.badge-new]="schoolUser.isAccountActivated!==true && schoolUser.isActive===true"
                  [class.badge-in-progress]="schoolUser.isAccountActivated!==true && schoolUser.isActive!==true"
                  [class.badge-on-hold]="schoolUser.isAccountActivated===true && schoolUser.isActive!==true"
                  >
                  <a href="mailto:{{schoolUser.emailId}}">{{schoolUser.emailId}}</a>
              </div>
              </td>
              <td>{{ schoolUser.countryCode }}</td>
              <td>{{ schoolUser.phoneNumber }}</td>
              <td class="add-user-roles user-detail-role">
                <div class="d-flex" *ngIf="!viewMode">
                  <p *ngFor="let role of schoolUser.role" class="badge fs-12 my-4 me-2">
                    <span [ngClass]="role.isModified ? 'highlighter': ''"></span>{{role.roleName}}
                    <img src="../assets/images/edit.svg" alt="edit" (click)="openEditRolePopup(role, schoolUser)" class="h12"/>
                  </p>
                  <span class="text-blue bg-transparent fs-12 px-0 m-auto cursor-pointer" (click)="getRoles(clientAccountId, independentSchoolId); roleSelect.open()">+ add</span>
                  <mat-select #roleSelect required [(ngModel)]="schoolUser.role" 
                    (selectionChange)="onRoleChange($event.value, schoolUser, i)" multiple panelClass="custom-panel-width">
                    @for (role of roles; track role) {
                      <mat-option [value]="role">{{role.roleName}}</mat-option>
                    }
                  </mat-select>
                </div>
                <div class="d-flex" *ngIf="viewMode">
                  <span *ngFor="let role of schoolUser.role?.slice(0,2)" class="badge fs-12 mr10" [ngClass]="role.roleId<=4?'primary':''">
                     {{role.roleName}}
                  </span>
                  <span *ngIf="schoolUser.role.length>0" class="badge count fs-12" (click)="previewPopup(schoolUser.role)" >#{{schoolUser.role.length}}</span>
                </div>
              </td>
              <td>
                <a class="cursor-pointer">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" (click)="
                  $event.preventDefault();
                  $event.stopPropagation();
                  ViewDocument(schoolUser)">
                    <path d="M22 10V15C22 20 20 22 15 22H9C4 22 2 20 2 15V9C2 4 4 2 9 2H14" stroke="#4F6681"
                      stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M22 10H18C15 10 14 9 14 6V2L22 10Z" stroke="#4F6681" stroke-width="1.5" stroke-linecap="round"
                      stroke-linejoin="round" />
                    <path d="M7 13H13" stroke="#4F6681" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M7 17H11" stroke="#4F6681" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </a>
              </td>
              <td class="sticky-right">
                <ng-container>
                  <a class="btn-action" (click)="editUser(schoolUser, i)" matTooltip="Edit details">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M11.05 3.00002L4.20829 10.2417C3.94996 10.5167 3.69996 11.0584 3.64996 11.4334L3.34162 14.1333C3.23329 15.1083 3.93329 15.775 4.89996 15.6084L7.58329 15.15C7.95829 15.0834 8.48329 14.8084 8.74162 14.525L15.5833 7.28335C16.7666 6.03335 17.3 4.60835 15.4583 2.86668C13.625 1.14168 12.2333 1.75002 11.05 3.00002Z"
                        stroke="#4F6681" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                        stroke-linejoin="round" />
                      <path d="M9.90845 4.20837C10.2668 6.50837 12.1334 8.26671 14.4501 8.50004" stroke="#4F6681"
                        stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M2.5 18.3334H17.5" stroke="#4F6681" stroke-width="1.5" stroke-miterlimit="10"
                        stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </a>
                  <a class="btn-action" (click)="deleteUser(schoolUser, i)" matTooltip="Delete details">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M10.4999 1.5C10.9141 1.5 11.2499 1.16421 11.2499 0.75C11.2499 0.335787 10.9141 0 10.4999 0H5.49992C5.0857 0 4.74992 0.335786 4.74992 0.75C4.74992 1.16421 5.0857 1.5 5.49992 1.5L10.4999 1.5ZM1.33325 3.58333H1.44226L2.13845 13.0111L2.13849 13.0117C2.23268 14.2735 3.28338 15.25 4.54891 15.25H11.4489C12.7167 15.25 13.7689 14.2699 13.8595 13.0053L13.8595 13.0051L14.5323 3.58333H14.6666C15.0808 3.58333 15.4166 3.24755 15.4166 2.83333C15.4166 2.41912 15.0808 2.08333 14.6666 2.08333H13.8351L13.8339 2.08333H2.13891L2.13826 2.08333H1.33325C0.919038 2.08333 0.583252 2.41912 0.583252 2.83333C0.583252 3.24755 0.919038 3.58333 1.33325 3.58333ZM3.63433 12.9L2.94634 3.58333H13.0285L12.3633 12.8981C12.3289 13.3784 11.9294 13.75 11.4489 13.75H4.54891C4.06954 13.75 3.6703 13.38 3.63435 12.9003L3.63433 12.9ZM10.4166 7C10.4166 6.58579 10.0808 6.25 9.66658 6.25C9.25237 6.25 8.91658 6.58579 8.91658 7V10.3333C8.91658 10.7475 9.25237 11.0833 9.66658 11.0833C10.0808 11.0833 10.4166 10.7475 10.4166 10.3333V7ZM6.74992 6.25C7.16413 6.25 7.49992 6.58579 7.49992 7V10.3333C7.49992 10.7475 7.16413 11.0833 6.74992 11.0833C6.3357 11.0833 5.99992 10.7475 5.99992 10.3333V7C5.99992 6.58579 6.3357 6.25 6.74992 6.25Z"
                        fill="#4F6681" />
                    </svg>
                  </a>
                </ng-container>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div *ngIf="!filteredSchoolUsers?.length" class="noDataFound">
        <h1>{{'No Data Found'}}</h1>
      </div>
    </div>
  </div>
</section>
